// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image[data-v-7c6b5d48]{border-radius:.25rem;transition-duration:.15s;width:100%}.image[data-v-7c6b5d48]:hover{opacity:.75}.name[data-v-7c6b5d48]{display:inline-block;font-weight:600}.quantity-small[data-v-7c6b5d48]{transform:scale(.8);transform-origin:right top}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
